import { render } from "./DesignSamples.vue?vue&type=template&id=eb0154f6"
import script from "./DesignSamples.vue?vue&type=script&lang=js"
export * from "./DesignSamples.vue?vue&type=script&lang=js"

import "./DesignSamples.vue?vue&type=style&index=0&id=eb0154f6&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__